module.exports = __webpack_public_path__ + "static/media/a-2.52c250c3.jpg";